// extracted by mini-css-extract-plugin
export default {"errorIcon":"errorIcon_errorIcon__2h6VB","errorMsg":"errorIcon_errorMsg__nqyzD"};